module.exports = "/_next/static/images/d5bde989294781dc4535bb280da5f80f-hero-experiment.jpg.webp";